import React from "react";
import { PropTypes } from "prop-types";
import { shortDisplayTime } from "../../utils/displayTime";

const CustomTimeStamp = ({ prevTime, currentTime, divname = "timestamp" }) => {
  return (
    <>
      <div className={`${divname}`}>
        <span className="text">{shortDisplayTime(prevTime)}</span>
        <span className="text">{" - "}</span>
        <span className="text">{shortDisplayTime(currentTime)}</span>
      </div>
    </>
  );
};

CustomTimeStamp.propTypes = {
  prevTime: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.instanceOf(Date),
  ]),
  currentTime: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.instanceOf(Date),
  ]),
  divname: PropTypes.string,
};

export default CustomTimeStamp;
